(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9843],{

/***/ 6406:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_0__);
 // 创建一个不进行服务器端渲染的组件

const EchoNextImage = next_dynamic__WEBPACK_IMPORTED_MODULE_0___default()(() => Promise.all(/* import() */[__webpack_require__.e(5675), __webpack_require__.e(4994)]).then(__webpack_require__.bind(__webpack_require__, 51566)), {
  ssr: false,
  loadableGenerated: {
    webpack: () => [/*require.resolve*/(51566)]
  }
});
/* harmony default export */ __webpack_exports__["Z"] = (EchoNextImage);

/***/ }),

/***/ 13156:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _arco_design_web_react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(56187);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);





class ErrorBoundary extends react__WEBPACK_IMPORTED_MODULE_0__.Component {
  constructor(props) {
    super(props);
    this.state = {
      hasError: false,
      error: null,
      errorInfo: null
    };
  }

  static getDerivedStateFromError(error) {
    return {
      hasError: true,
      error,
      errorInfo: null
    };
  }

  componentDidCatch(error, errorInfo) {
    this.setState({
      error,
      errorInfo
    }); // 你可以将错误日志记录到外部服务

    console.error('ErrorBoundary caught an error', error, errorInfo); // 将错误信息传递给自定义错误页面

    next_router__WEBPACK_IMPORTED_MODULE_1___default().push({
      pathname: '/_error',
      query: {
        error: error.toString(),
        errorInfo: errorInfo.componentStack
      }
    });
  }

  render() {
    if (this.state.hasError) {
      return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_arco_design_web_react__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        onClick: () => {
          next_router__WEBPACK_IMPORTED_MODULE_1___default().push({
            pathname: '/board'
          });
        },
        children: "Go to Dashboard"
      });
    }

    return this.props.children;
  }

}

/* harmony default export */ __webpack_exports__["Z"] = (ErrorBoundary);

/***/ }),

/***/ 41802:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(59499);
/* harmony import */ var lodash_has__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(18721);
/* harmony import */ var lodash_has__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash_has__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(4730);
/* harmony import */ var _arco_design_web_react__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(15695);
/* harmony import */ var _utils_regionFlags__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(37131);
/* harmony import */ var _index_module_less__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(27362);
/* harmony import */ var _index_module_less__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_index_module_less__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85893);



const _excluded = ["region", "size", "shape", "style"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }






const FlagIcon = props => {
  const {
    region,
    size = 16,
    shape,
    style
  } = props,
        rest = (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(props, _excluded);

  if ((region === null || region === void 0 ? void 0 : region.id) === '') {
    const FlagModule = _utils_regionFlags__WEBPACK_IMPORTED_MODULE_2__/* ["default"].GLOBAL */ .Z.GLOBAL;
    return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("div", {
      className: (_index_module_less__WEBPACK_IMPORTED_MODULE_5___default().flagWarp),
      style: {
        boxShadow: '0 0 8px #ccc'
      },
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(FlagModule, {
        className: (_index_module_less__WEBPACK_IMPORTED_MODULE_5___default().flag),
        size: 34
      })
    });
  }

  if (!region) {
    return null;
  }

  if (!lodash_has__WEBPACK_IMPORTED_MODULE_0___default()(_utils_regionFlags__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, region.id)) {
    return null;
  }

  const FlagModule = _utils_regionFlags__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z[region.id];

  if (shape === 'circle') {
    return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("div", {
      className: (_index_module_less__WEBPACK_IMPORTED_MODULE_5___default().flagWarp),
      style: {
        boxShadow: '0 0 8px #ccc'
      },
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(FlagModule, {
        className: (_index_module_less__WEBPACK_IMPORTED_MODULE_5___default().flag),
        width: 34
      })
    });
  }

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_arco_design_web_react__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
    content: region.name,
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(FlagModule, _objectSpread({
      width: size,
      style: _objectSpread({
        boxShadow: '0 0 8px #ccc',
        lineHeight: 1,
        display: 'inline-block'
      }, style)
    }, rest))
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (FlagIcon);

/***/ }),

/***/ 83889:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _index_module_less__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(73007);
/* harmony import */ var _index_module_less__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_index_module_less__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);





const GlobalLoading = props => {
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
    children: [props.children, props.loading ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
      className: (_index_module_less__WEBPACK_IMPORTED_MODULE_1___default().loadingWrap),
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (_index_module_less__WEBPACK_IMPORTED_MODULE_1___default().loading)
      })
    }) : null]
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (GlobalLoading);

/***/ }),

/***/ 47742:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "h": function() { return /* binding */ SEOHeader; },
/* harmony export */   "i": function() { return /* binding */ SEOConfig; }
/* harmony export */ });
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);



const SEOConfig = {
  title: `EchoTik - TikTok Shop Sellers must-have analytics Tool`,
  keywords: `TikTok Shop Seller, Data Analytics, Influencer`,
  description: `EchoTik is a TikTok shop data analytics platform that helps sellers or influencers find out goods, videos, music`
};
function SEOHeader(_ref) {
  let {
    title = SEOConfig.title,
    description = SEOConfig.description,
    keywords = SEOConfig.keywords,
    extra = null
  } = _ref;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_0___default()), {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
      charSet: "UTF-8"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("link", {
      rel: "shortcut icon",
      type: "image/x-icon",
      href: "/icon.ico"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
      name: "viewport",
      content: "width=device-width, initial-scale=1.0"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
      httpEquiv: "X-UA-Compatible",
      content: "ie=edge"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("title", {
      children: title
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
      name: "keywords",
      content: keywords
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
      name: "description",
      content: description
    }), extra]
  });
}

/***/ }),

/***/ 18737:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var next_script__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4298);
/* harmony import */ var next_script__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_script__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);




/* harmony default export */ __webpack_exports__["Z"] = (_ref => {
  let {
    lang
  } = _ref;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("noscript", {
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("iframe", {
        title: "gtag-manager",
        src: "https://www.googletagmanager.com/ns.html?id=GTM-WT3RGNW",
        height: "0",
        width: "0",
        style: {
          display: 'none',
          visibility: 'hidden'
        }
      })
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)((next_script__WEBPACK_IMPORTED_MODULE_0___default()), {
      strategy: "lazyOnload",
      dangerouslySetInnerHTML: {
        __html: `
            ;(function (w, d, s, l, i) {
              w[l] = w[l] || []
              w[l].push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' })
              var f = d.getElementsByTagName(s)[0],
                j = d.createElement(s),
                dl = l != 'dataLayer' ? '&l=' + l : ''
              j.async = true
              j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl
              f.parentNode.insertBefore(j, f)
            })(window, document, 'script', 'dataLayer', 'GTM-WT3RGNW')
          `
      }
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)((next_script__WEBPACK_IMPORTED_MODULE_0___default()), {
      strategy: "lazyOnload",
      async: true,
      src: "https://www.googletagmanager.com/gtag/js?id=G-F9R54EGLQV"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)((next_script__WEBPACK_IMPORTED_MODULE_0___default()), {
      strategy: "lazyOnload",
      async: true,
      src: "https://www.googletagmanager.com/gtag/js?id=UA-233959850-1"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)((next_script__WEBPACK_IMPORTED_MODULE_0___default()), {
      strategy: "lazyOnload",
      async: true,
      src: "https://www.googletagmanager.com/gtag/js?id=AW-11015810512"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)((next_script__WEBPACK_IMPORTED_MODULE_0___default()), {
      strategy: "lazyOnload",
      dangerouslySetInnerHTML: {
        __html: `
          window.dataLayer = window.dataLayer || [];
          function gtag(){
            dataLayer.push(arguments);
          }
          gtag('js', new Date());
        
          gtag('config', 'AW-11015810512', { 'allow_enhanced_conversions': true });
          `
      }
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)((next_script__WEBPACK_IMPORTED_MODULE_0___default()), {
      strategy: "lazyOnload",
      dangerouslySetInnerHTML: {
        __html: `
            // We pre-filled your app ID in the widget URL: 'https://widget.intercom.io/widget/jr0fp2wt'
            ;(function () {
              var w = window
              var ic = w.Intercom
              if (typeof ic === 'function') {
                ic('reattach_activator')
                ic('update', w.intercomSettings)
              } else {
                var d = document
                var i = function () {
                  i.c(arguments)
                }
                i.q = []
                i.c = function (args) {
                  i.q.push(args)
                }
                w.Intercom = i
                var l = function () {
                  var s = d.createElement('script')
                  s.type = 'text/javascript'
                  s.async = true
                  s.src = 'https://widget.intercom.io/widget/jr0fp2wt'
                  var x = d.getElementsByTagName('script')[0]
                  x.parentNode.insertBefore(s, x)
                }
                if (document.readyState === 'complete') {
                  l()
                } else if (w.attachEvent) {
                  w.attachEvent('onload', l)
                } else {
                  w.addEventListener('load', l, false)
                }
              }
            })()
          `
      }
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)((next_script__WEBPACK_IMPORTED_MODULE_0___default()), {
      strategy: "lazyOnload",
      id: "cookieyes",
      async: true,
      src: "https://cdn-cookieyes.com/client_data/1575744314c042d6d352e2a3/script.js"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)((next_script__WEBPACK_IMPORTED_MODULE_0___default()), {
      strategy: "lazyOnload",
      id: "baidu-agl",
      dangerouslySetInnerHTML: {
        __html: `
              window._agl = window._agl || [];
              (function () {
                _agl.push(
                  ['production', '_f7L2XwGXjyszb4d1e2oxPybgD']
                );
                (function () {
                  var agl = document.createElement('script');
                  agl.type = 'text/javascript';
                  agl.async = true;
                  agl.src = 'https://fxgate.baidu.com/angelia/fcagl.js?production=_f7L2XwGXjyszb4d1e2oxPybgD';
                  var s = document.getElementsByTagName('script')[0];
                  s.parentNode.insertBefore(agl, s);
                })();
              })();
            `
      }
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)((next_script__WEBPACK_IMPORTED_MODULE_0___default()), {
      id: "baidu",
      strategy: "beforeInteractive",
      dangerouslySetInnerHTML: {
        __html: `
              var _hmt = _hmt || [];
              (function() {
                var hm = document.createElement("script");
                hm.src = "https://hm.baidu.com/hm.js?a19dc14c14357c20224d43189684bf8c";
                var s = document.getElementsByTagName("script")[0]; 
                s.parentNode.insertBefore(hm, s);
              })();
            `
      }
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)((next_script__WEBPACK_IMPORTED_MODULE_0___default()), {
      id: "meta-pixel",
      strategy: "afterInteractive",
      dangerouslySetInnerHTML: {
        __html: `
            !function(f,b,e,v,n,t,s)
  {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
  n.callMethod.apply(n,arguments):n.queue.push(arguments)};
  if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
  n.queue=[];t=b.createElement(e);t.async=!0;
  t.src=v;s=b.getElementsByTagName(e)[0];
  s.parentNode.insertBefore(t,s)}(window, document,'script',
  'https://connect.facebook.net/en_US/fbevents.js');
  fbq('init', '449222451523674');
  fbq('track', 'PageView');
          `
      }
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("noscript", {
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("img", {
        height: "1",
        width: "1",
        style: {
          display: 'none'
        },
        src: "https://www.facebook.com/tr?id=449222451523674&ev=PageView&noscript=1"
      })
    })]
  });
});

/***/ }),

/***/ 52765:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_Search; },
  "F": function() { return /* binding */ isDetailPage; }
});

// EXTERNAL MODULE: ./node_modules/lodash/isEmpty.js
var isEmpty = __webpack_require__(41609);
var isEmpty_default = /*#__PURE__*/__webpack_require__.n(isEmpty);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./src/utils/useLocale.ts
var useLocale = __webpack_require__(83126);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/es/Space/index.js
var Space = __webpack_require__(77303);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/es/Spin/index.js + 1 modules
var Spin = __webpack_require__(62258);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/es/Empty/index.js
var Empty = __webpack_require__(43061);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/es/Select/index.js
var Select = __webpack_require__(94558);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/es/AutoComplete/index.js
var AutoComplete = __webpack_require__(95383);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/es/Tooltip/index.js
var Tooltip = __webpack_require__(15695);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/es/Button/index.js + 1 modules
var Button = __webpack_require__(56187);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/components/AnimatePresence/index.mjs + 3 modules
var AnimatePresence = __webpack_require__(13114);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/render/components/motion/proxy.mjs + 70 modules
var proxy = __webpack_require__(74070);
// EXTERNAL MODULE: ./src/types/common.ts
var common = __webpack_require__(43397);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/icon/react-icon/IconClose/index.js
var IconClose = __webpack_require__(59547);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/icon/react-icon/IconSearch/index.js
var IconSearch = __webpack_require__(22208);
// EXTERNAL MODULE: ./src/components/Search/index.module.less
var index_module = __webpack_require__(92564);
var index_module_default = /*#__PURE__*/__webpack_require__.n(index_module);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./src/api/common.ts
var api_common = __webpack_require__(74169);
// EXTERNAL MODULE: ./src/components/EchoNextImage/index.tsx
var EchoNextImage = __webpack_require__(6406);
// EXTERNAL MODULE: ./src/assets/user2x.png
var user2x = __webpack_require__(87707);
// EXTERNAL MODULE: ./src/assets/video-play2x.png
var video_play2x = __webpack_require__(77354);
// EXTERNAL MODULE: ./src/assets/shop2x.png
var shop2x = __webpack_require__(81186);
// EXTERNAL MODULE: ./src/utils/constants.ts
var constants = __webpack_require__(42586);
// EXTERNAL MODULE: ./node_modules/ahooks/es/useSetState/index.js
var useSetState = __webpack_require__(96638);
// EXTERNAL MODULE: ./node_modules/ahooks/es/useDebounceFn/index.js
var useDebounceFn = __webpack_require__(85980);
// EXTERNAL MODULE: ./node_modules/axios/index.js
var axios = __webpack_require__(9669);
var axios_default = /*#__PURE__*/__webpack_require__.n(axios);
// EXTERNAL MODULE: ./src/utils/searchHistoryCache.ts
var searchHistoryCache = __webpack_require__(43059);
// EXTERNAL MODULE: ./src/assets/ic_translate_blue_svg.svg
var ic_translate_blue_svg = __webpack_require__(43892);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 18 modules
var es = __webpack_require__(25617);
// EXTERNAL MODULE: ./src/hooks/useRegionOptions.ts
var useRegionOptions = __webpack_require__(3770);
// EXTERNAL MODULE: ./src/components/FlagIcon/index.tsx
var FlagIcon = __webpack_require__(41802);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/es/Input/index.js + 6 modules
var Input = __webpack_require__(1393);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/es/Upload/index.js + 10 modules
var Upload = __webpack_require__(39612);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/es/Message/index.js + 1 modules
var Message = __webpack_require__(80507);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/es/Progress/index.js + 3 modules
var Progress = __webpack_require__(31604);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/icon/react-icon/IconEdit/index.js
var IconEdit = __webpack_require__(61803);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/icon/react-icon/IconPlus/index.js
var IconPlus = __webpack_require__(84566);
// EXTERNAL MODULE: ./node_modules/cookies-next/lib/index.js
var lib = __webpack_require__(47041);
// EXTERNAL MODULE: ./src/api/request.ts
var request = __webpack_require__(84425);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/Search/upload-image.tsx


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }










const TextArea = Input/* default.TextArea */.Z.TextArea;
const uploadUrl = `${request/* baseOrigin */.RU}/api/v1/tools/image/upload`;

const UploadImage = props => {
  const {
    onImageSearch,
    onClose,
    imageSearchLoading
  } = props;
  const {
    0: file,
    1: setFile
  } = (0,react.useState)(null);
  const {
    0: textValue,
    1: setTextValue
  } = (0,react.useState)('');
  const {
    0: resData,
    1: setResData
  } = (0,react.useState)('');
  const {
    0: prevLoading,
    1: setPrevLoading
  } = (0,react.useState)(false);
  const {
    0: shouldScroll,
    1: setShouldScroll
  } = (0,react.useState)(false);
  const t = (0,useLocale/* default */.Z)();
  const token = (0,lib.getCookie)(constants/* TOKEN_COOKIE */.Md);
  const lang = (0,lib.getCookie)(constants/* LANG_COOKIE */.Yk);
  const currency = (0,lib.getCookie)(constants/* CURRENCY_COOKIE */.SM);
  const region = (0,lib.getCookie)(constants/* REGION_COOKIE */.jO);
  (0,react.useEffect)(() => {
    // 当imageSearchLoading从true变为false时，滚动到表格
    if (shouldScroll && prevLoading && !imageSearchLoading) {
      const tableElement = document.getElementById('table-sort-wrap');

      if (tableElement) {
        tableElement.scrollIntoView({
          behavior: 'smooth'
        });
        setShouldScroll(false); // 滚动后重置状态
      }
    }

    setPrevLoading(imageSearchLoading);
  }, [imageSearchLoading, shouldScroll, prevLoading]);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: "p-3 relative bg-white rounded-lg shadow-lg max-w-5xl mx-auto",
    style: {
      height: '226px',
      width: '1200px'
    },
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(IconClose/* default */.Z, {
      onClick: onClose,
      className: "text-black text-xl absolute top-4 right-4 cursor-pointer"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "text-center text-base font-bold mb-4",
      children: t['search_by_image_placeholder']
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "flex items-stretch justify-center gap-6 h-[180px] px-4",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "text-center w-[45%] border border-dashed border-gray-300 rounded-lg overflow-hidden bg-gray-50 hover:border-blue-400 transition-colors flex items-center justify-center h-full",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "w-full h-full flex flex-col items-center justify-center",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(Upload/* default */.Z, {
            action: uploadUrl,
            headers: {
              Authorization: `Bearer ${token}`,
              'x-lang': lang,
              'x-currency': currency,
              'x-region': region
            },
            fileList: file ? [file] : [],
            showUploadList: false,
            onChange: (_, currentFile) => {
              setFile(_objectSpread(_objectSpread({}, currentFile), {}, {
                url: currentFile !== null && currentFile !== void 0 && currentFile.originFile ? URL.createObjectURL(currentFile.originFile) : ''
              }));

              if (currentFile.status === 'done') {
                var _currentFile$response;

                setResData(currentFile === null || currentFile === void 0 ? void 0 : (_currentFile$response = currentFile.response) === null || _currentFile$response === void 0 ? void 0 : _currentFile$response.data);
                Message/* default.success */.Z.success(t['upload_image_success']);
              }
            },
            onProgress: currentFile => {
              setFile(currentFile);
            },
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: '',
              children: file && file.url ? /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                className: "custom-upload-avatar w-full h-full flex items-center justify-center",
                children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                  className: "relative w-[85%] h-[85%] border rounded-md overflow-hidden",
                  children: [/*#__PURE__*/(0,jsx_runtime.jsx)("img", {
                    src: file.url,
                    className: "w-full h-full object-contain",
                    style: {
                      maxHeight: '160px'
                    }
                  }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                    className: "absolute inset-0 hover:bg-black/10 transition-colors flex items-center justify-center opacity-0 hover:opacity-100",
                    children: /*#__PURE__*/(0,jsx_runtime.jsx)(IconEdit/* default */.Z, {
                      className: "text-2xl text-white p-1 bg-black/40 rounded-full cursor-pointer"
                    })
                  }), file.status === 'uploading' && file.percent < 100 && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                    className: "absolute inset-0 bg-black/20 flex items-center justify-center",
                    children: /*#__PURE__*/(0,jsx_runtime.jsx)(Progress/* default */.Z, {
                      percent: file.percent,
                      type: "circle",
                      size: "default",
                      className: "scale-125",
                      style: {
                        position: 'absolute',
                        left: '50%',
                        top: '50%',
                        transform: 'translateX(-50%) translateY(-50%)'
                      }
                    })
                  })]
                })
              }) : /*#__PURE__*/(0,jsx_runtime.jsxs)("label", {
                htmlFor: "file-upload",
                className: "cursor-pointer flex flex-col items-center justify-center",
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                  className: "w-10 h-10 flex items-center justify-center bg-gradient-to-r from-[#655aec] to-purple-500 text-white rounded-full mb-2",
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)(IconPlus/* default */.Z, {})
                }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                  className: "text-sm font-semibold mb-1",
                  children: t['upload_image']
                }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
                  className: "text-xs text-gray-500 text-center",
                  children: [t['click_or_drag_image_here'], /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), t['support_image_format']]
                })]
              })
            })
          })
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "w-[55%] flex flex-col gap-2",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(TextArea, {
          value: textValue,
          onChange: val => {
            setTextValue(val);
          },
          placeholder: t['search_by_image_tips'],
          className: "h-[180px] w-full border border-gray-300 rounded-lg p-2 flex-grow"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "flex justify-end",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
            disabled: imageSearchLoading,
            className: `border px-8 py-2 rounded-lg text-sm font-medium transition-all duration-300 flex items-center justify-center min-w-[100px] ${imageSearchLoading ? 'bg-gray-200 text-gray-400 cursor-not-allowed border-gray-300 opacity-70 hover:shadow-none' : 'bg-gradient-to-r from-[#655aec] to-[#a78bfa] text-white border-transparent cursor-pointer hover:shadow-md hover:shadow-blue-300/50 hover:brightness-105'}`,
            onClick: () => {
              if (!file) {
                Message/* default.error */.Z.error(t['search_by_image_error']);
                return;
              }

              setShouldScroll(true); // 点击搜索按钮时设置滚动标志

              onImageSearch === null || onImageSearch === void 0 ? void 0 : onImageSearch(resData, textValue);
            },
            children: imageSearchLoading ? /*#__PURE__*/(0,jsx_runtime.jsx)(Spin/* default */.Z, {
              dot: true
            }) : t['search_by_image_button']
          })
        })]
      })]
    })]
  });
};

/* harmony default export */ var upload_image = (UploadImage);
// EXTERNAL MODULE: ./node_modules/react-icons/md/index.esm.js
var index_esm = __webpack_require__(5434);
;// CONCATENATED MODULE: ./src/components/Search/index.tsx




























function isDetailPage(pathname) {
  const regex = /\[id\]/;

  if (regex.test(pathname)) {
    return true;
  }

  return false;
}

const Search = props => {
  const {
    theme = 'dark',
    defaultType = common/* SearchTypes.Influencer */.ai.Influencer,
    defaultValue = '',
    onSearch,
    setCurrentKeyword,
    autoJumpWhenTypeChange = false,
    inputClassName,
    searchClassName,
    searchButtonClassName,
    translateClassName,
    onSelect,
    isGlobal,
    autoFocused,
    visible,
    resetFlag,
    searchByImage = false,
    onImageSearch,
    imageSearchLoading,
    onImageSearchClose
  } = props;
  const t = (0,useLocale/* default */.Z)();
  const router = (0,next_router.useRouter)();
  const {
    0: type,
    1: setType
  } = (0,react.useState)(defaultType);
  const {
    0: value,
    1: setValue
  } = (0,react.useState)(defaultValue);
  const {
    0: fetching,
    1: setFetching
  } = (0,react.useState)(true);
  const {
    0: searchResult,
    1: setSearchResult
  } = (0,react.useState)([]);
  const {
    0: isFocus,
    1: setIsFocus
  } = (0,react.useState)(false);
  const [historyMap, setHistoryMap] = (0,useSetState/* default */.Z)(searchHistoryCache/* default.defaultHistory */.Z.defaultHistory);
  const {
    0: translateLoading,
    1: setTranslateLoading
  } = (0,react.useState)(false);
  const inputRef = (0,react.useRef)(null);
  const {
    0: isSearchByImageModalVisible,
    1: setIsSearchByImageModalVisible
  } = (0,react.useState)(false);
  const configs = [{
    id: common/* SearchTypes.Influencer */.ai.Influencer,
    title: t['navbar.search.result.influencer'],
    placeholder: t['search.placeholder.influencer'],
    listRouter: '/influencers',
    api: (params, config) => {
      return (0,api_common/* getSearchApi */.V3)('influencers', params, config);
    },
    render: () => {
      return searchResult.map((influencer, index) => {
        return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          onClick: () => {
            onSelect === null || onSelect === void 0 ? void 0 : onSelect();
            router.push(`/influencers/${influencer.influencer_id}`).then(() => {// if (isDetailPage(router.pathname)) {
              //   router.reload()
              // }
            });
          },
          className: (index_module_default()).resultItem,
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: (index_module_default()).cover,
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(EchoNextImage/* default */.Z, {
              src: influencer.avatar_url,
              width: 44,
              height: 44,
              style: {
                borderRadius: '50%'
              },
              alt: "avatar",
              errorSrc: user2x/* default.src */.Z.src
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Space/* default */.Z, {
            direction: "vertical",
            size: 2,
            children: [influencer.highlight ? /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: (index_module_default()).title,
              dangerouslySetInnerHTML: {
                __html: influencer.highlight
              }
            }) : /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: (index_module_default()).title,
              children: influencer.influencer_name
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Space/* default */.Z, {
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(FlagIcon/* default */.Z, {
                region: influencer.region
              }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                className: (index_module_default()).subtitle,
                children: ["@", influencer.unique_id]
              })]
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: (index_module_default()).fans,
              children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                children: [t['workplace.column.followers'], ": ", influencer === null || influencer === void 0 ? void 0 : influencer.follower_count]
              })
            })]
          })]
        }, index);
      });
    }
  }, {
    id: common/* SearchTypes.Video */.ai.Video,
    title: t['navbar.search.result.videos'],
    placeholder: t['search.placeholder.video'],
    listRouter: '/videos',
    api: (params, config) => {
      return (0,api_common/* getSearchApi */.V3)('videos', params, config);
    },
    render: () => {
      return searchResult.map((video, index) => {
        return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: (index_module_default()).resultItem,
          onClick: () => {
            onSelect === null || onSelect === void 0 ? void 0 : onSelect();
            router.push(`/videos/${video.video_id}`).then(() => {// if (isDetailPage(router.pathname)) {
              //   router.reload()
              // }
            });
          },
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: (index_module_default()).cover,
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(EchoNextImage/* default */.Z, {
              src: video.cover_url,
              width: 44,
              height: 44,
              style: {
                borderRadius: 8
              },
              alt: "cover",
              errorSrc: video_play2x/* default.src */.Z.src
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Space/* default */.Z, {
            direction: "vertical",
            size: 2,
            children: [video.highlight ? /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: (index_module_default()).title,
              dangerouslySetInnerHTML: {
                __html: video.highlight
              }
            }) : /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: (index_module_default()).title,
              children: video.video_title
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: (index_module_default()).subtitle,
              children: [t['navbar.search.result.videoCount'], video.views_count]
            })]
          })]
        }, index);
      });
    }
  }, {
    id: common/* SearchTypes.Product */.ai.Product,
    title: t['navbar.search.result.products'],
    placeholder: t['search.placeholder.product'],
    listRouter: '/products',
    api: (params, config) => {
      return (0,api_common/* getSearchApi */.V3)('products', params, config);
    },
    render: () => {
      return searchResult.map((product, index) => /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: (index_module_default()).resultItem,
        onClick: () => {
          onSelect === null || onSelect === void 0 ? void 0 : onSelect();
          router.push(`/products/${product.product_id}`).then(() => {// if (isDetailPage(router.pathname)) {
            //   router.reload()
            // }
          });
        },
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: (index_module_default()).cover,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(EchoNextImage/* default */.Z, {
            src: product.cover_url,
            width: 44,
            height: 44,
            style: {
              borderRadius: 4
            },
            alt: "cover",
            errorSrc: shop2x/* default.src */.Z.src
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Space/* default */.Z, {
          direction: "vertical",
          size: 2,
          children: [product !== null && product !== void 0 && product.highlight ? /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: (index_module_default()).title,
            dangerouslySetInnerHTML: {
              __html: product === null || product === void 0 ? void 0 : product.highlight
            }
          }) : /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: (index_module_default()).title,
            children: product.product_name
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: (index_module_default()).subtitle,
            children: [t['navbar.search.result.sales'], product.total_sale_cnt]
          })]
        })]
      }, index));
    }
  }, {
    id: common/* SearchTypes.Live */.ai.Live,
    title: t['navbar.search.result.lives'],
    placeholder: t['search.placeholder.live'],
    listRouter: '/live',
    api: (params, config) => {
      return (0,api_common/* getSearchApi */.V3)('lives', params, config);
    },
    render: () => {
      return searchResult.map((live, index) => /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: (index_module_default()).resultItem,
        onClick: () => {
          onSelect === null || onSelect === void 0 ? void 0 : onSelect();
          router.push(`/live/${live.live_id}`).then(() => {// if (isDetailPage(router.pathname)) {
            //   router.reload()
            // }
          });
        },
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: (index_module_default()).cover,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(EchoNextImage/* default */.Z, {
            src: live.cover_url,
            width: 44,
            height: 44,
            style: {
              borderRadius: 4
            },
            alt: "cover",
            errorSrc: video_play2x/* default.src */.Z.src
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Space/* default */.Z, {
          direction: "vertical",
          size: 2,
          children: [live.highlight ? /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: (index_module_default()).title,
            dangerouslySetInnerHTML: {
              __html: live.highlight
            }
          }) : /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: (index_module_default()).title,
            children: live.live_title
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: (index_module_default()).subtitle,
            children: ["@", live.influencer.unique_id, /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
              children: live.start_time
            })]
          })]
        })]
      }, index));
    }
  }, {
    id: common/* SearchTypes.Shop */.ai.Shop,
    title: t['search.type.shop'],
    placeholder: t['search.placeholder.shop'],
    listRouter: '/shops',
    api: (params, config) => {
      return (0,api_common/* getSearchApi */.V3)('sellers', params, config);
    },
    render: () => {
      return searchResult.map((shop, index) => /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: (index_module_default()).resultItem,
        onClick: () => {
          onSelect === null || onSelect === void 0 ? void 0 : onSelect();
          router.push(`/shops/${shop.seller_id}`).then(() => {// if (isDetailPage(router.pathname)) {
            //   router.reload()
            // }
          });
        },
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: (index_module_default()).cover,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(EchoNextImage/* default */.Z, {
            src: shop.cover_url,
            width: 44,
            height: 44,
            style: {
              borderRadius: 4
            },
            alt: "cover",
            errorSrc: shop2x/* default.src */.Z.src
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Space/* default */.Z, {
          direction: "vertical",
          size: 2,
          children: [shop !== null && shop !== void 0 && shop.highlight ? /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: (index_module_default()).title,
            dangerouslySetInnerHTML: {
              __html: shop === null || shop === void 0 ? void 0 : shop.highlight
            }
          }) : /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: (index_module_default()).title,
            children: shop.seller_name
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: (index_module_default()).subtitle,
            children: [t['product.detail.30.sales'], " ", shop.sale_30d_cnt]
          })]
        })]
      }, index));
    }
  }, {
    id: common/* SearchTypes.Hashtag */.ai.Hashtag,
    title: t['video.detail.hashTag'],
    placeholder: t['search.placeholder.hashtags'],
    listRouter: '/hashtags',
    api: (params, config) => {
      return (0,api_common/* getSearchApi */.V3)('tags', params, config);
    },
    render: () => {
      return searchResult.map((tag, index) => /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: (index_module_default()).resultItem,
        onClick: () => {
          onSelect === null || onSelect === void 0 ? void 0 : onSelect();
          router.push(`/hashtags/${tag.tag_id}`).then(() => {// if (isDetailPage(router.pathname)) {
            //   router.reload()
            // }
          });
        },
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Space/* default */.Z, {
          direction: "vertical",
          size: 2,
          children: [tag.highlight ? /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: (index_module_default()).title,
            dangerouslySetInnerHTML: {
              __html: tag.highlight
            }
          }) : /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: (index_module_default()).title,
            children: tag.tag_title
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: (index_module_default()).subtitle,
            children: [t['influencer.column.videos_count'], " ", tag.video_count]
          })]
        })
      }, tag.tag_id));
    }
  }];
  const currentConfig = configs.find(item => item.id === type);
  const {
    region
  } = (0,es/* useSelector */.v9)(state => state.ssr);
  const {
    regionOptions
  } = (0,useRegionOptions/* default */.Z)(); // eslint-disable-next-line @typescript-eslint/no-non-null-assertion

  const activeRegion = regionOptions.find(item => item.region === region);

  const handleSearch = () => {
    if (onSearch) {
      onSearch(value);
      value.trim() && updateCurrentHistory(value);

      if (isGlobal) {
        router.push({
          pathname: currentConfig.listRouter,
          query: {
            keyword: value,
            isGlobalSearch: isGlobal
          }
        });
      }

      return;
    }

    if (value.trim() === '') {
      return;
    }

    updateCurrentHistory(value);
    router.push({
      pathname: currentConfig.listRouter,
      query: {
        keyword: value
      }
    });
  };

  (0,react.useEffect)(() => {
    setCurrentKeyword === null || setCurrentKeyword === void 0 ? void 0 : setCurrentKeyword(value);
  }, [value]);
  (0,react.useEffect)(() => {
    if (autoFocused && inputRef !== null && inputRef !== void 0 && inputRef.current && visible) {
      setTimeout(() => {
        var _inputRef$current;

        inputRef === null || inputRef === void 0 ? void 0 : (_inputRef$current = inputRef.current) === null || _inputRef$current === void 0 ? void 0 : _inputRef$current.focus();
      });
    }
  }, [autoFocused, visible]);

  const updateCurrentHistory = keyword => {
    setHistoryMap({
      [currentConfig.id]: [keyword.trim(), ...historyMap[currentConfig.id].filter(item => item !== keyword.trim())].slice(0, 5)
    });
  };

  const debounceFetch = (0,useDebounceFn/* default */.Z)((keyword, abortController) => {
    var _router$query;

    const currentParams = {
      keyword
    };
    const order = router === null || router === void 0 ? void 0 : (_router$query = router.query) === null || _router$query === void 0 ? void 0 : _router$query.order;

    if (order) {
      currentParams.order = order;
    }

    setFetching(true);
    currentConfig.api(currentParams, {
      signal: abortController.signal
    }).then(res => {
      if ([constants/* SUCCESS_CODE */.Gh, constants/* BLUR_CODE */.HH].includes(res.data.code)) {
        isFocus && updateCurrentHistory(keyword);
        setSearchResult(res.data.data);
        setFetching(false);
        return;
      }

      return Promise.reject();
    }).catch(err => {
      if (axios_default().isCancel(err)) {
        return;
      }

      setSearchResult([]);
      setFetching(false);
    });
  }, {
    wait: 400
  });

  const renderResult = () => {
    if (!value.trim()) {
      return null;
    }

    if (fetching) {
      return /*#__PURE__*/(0,jsx_runtime.jsx)(Spin/* default */.Z, {
        style: {
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          height: 100
        }
      });
    }

    return searchResult.length ? currentConfig.render() : /*#__PURE__*/(0,jsx_runtime.jsx)(Empty/* default */.Z, {
      style: {
        height: 100
      }
    });
  };

  (0,react.useEffect)(() => {
    if (value.trim() === '') {
      setSearchResult([]);
      setFetching(true);
      return;
    }

    const abortController = new AbortController();
    debounceFetch.run(value, abortController);
    return () => {
      abortController.abort();
    };
  }, [value]);
  (0,react.useEffect)(() => {
    if (historyMap === searchHistoryCache/* default.defaultHistory */.Z.defaultHistory) {
      return;
    }

    searchHistoryCache/* default.setCache */.Z.setCache(historyMap);
  }, [historyMap]);
  const historyVisible = isFocus && !value;
  (0,react.useEffect)(() => {
    if (historyVisible) {
      setHistoryMap(searchHistoryCache/* default.getCache */.Z.getCache());
    }
  }, [historyVisible]);

  const renderHistory = () => {
    const currentHistory = historyMap[currentConfig.id];

    if (isEmpty_default()(currentHistory)) {
      return null;
    }

    return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: (index_module_default()).historyHeader,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
          className: (index_module_default()).historyTitle,
          children: t['search.search_history']
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
          className: (index_module_default()).historyClear,
          onClick: () => {
            setHistoryMap({
              [currentConfig.id]: []
            });
          },
          children: t['search.clear_history']
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        children: currentHistory.map((text, index) => /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: (index_module_default()).historyItem,
          onClick: () => {
            setValue(text);
          },
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
            className: (index_module_default()).historyItemText,
            children: text
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
            className: (index_module_default()).historyDelete,
            onClick: e => {
              e.stopPropagation();
              setHistoryMap({
                [currentConfig.id]: currentHistory.filter(item => item !== text)
              });
            },
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(IconClose/* default */.Z, {})
          })]
        }, index))
      })]
    });
  };

  const onTranslate = () => {
    if (translateLoading || !value) return;
    setTranslateLoading(true);
    (0,api_common/* getTranslateApi */.SW)({
      keyword: value
    }).then(res => {
      if ([constants/* SUCCESS_CODE */.Gh, constants/* BLUR_CODE */.HH].includes(res.data.code)) {
        setValue(res.data.data.to);
        setIsFocus(true);
      }
    }).finally(() => {
      setTranslateLoading(false);
    });
  };

  (0,react.useEffect)(() => {
    if (resetFlag) {
      setValue('');
    }
  }, [resetFlag]);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(AnimatePresence/* AnimatePresence */.M, {
    mode: "wait",
    children: isSearchByImageModalVisible ? /*#__PURE__*/(0,jsx_runtime.jsx)(proxy/* motion.div */.E.div, {
      initial: {
        opacity: 0,
        scale: 0.95,
        y: 10
      },
      animate: {
        opacity: 1,
        scale: 1,
        y: 0
      },
      exit: {
        opacity: 0,
        scale: 0.95,
        y: 10
      },
      transition: {
        type: 'spring',
        stiffness: 300,
        damping: 30,
        duration: 0.3
      },
      className: "flex justify-center w-full",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(upload_image, {
        onImageSearch: onImageSearch,
        onClose: () => {
          setIsSearchByImageModalVisible(false);
          onImageSearchClose === null || onImageSearchClose === void 0 ? void 0 : onImageSearchClose();
        },
        imageSearchLoading: imageSearchLoading || false
      })
    }, "upload-image") : /*#__PURE__*/(0,jsx_runtime.jsxs)(proxy/* motion.div */.E.div, {
      initial: {
        opacity: 0,
        y: -10
      },
      animate: {
        opacity: 1,
        y: 0
      },
      exit: {
        opacity: 0,
        y: -10
      },
      transition: {
        type: 'spring',
        stiffness: 300,
        damping: 30,
        duration: 0.3
      },
      className: classnames_default()((index_module_default()).search, {
        [(index_module_default()).darkSearch]: theme === 'dark'
      }, searchClassName),
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Select/* default */.Z, {
        value: type,
        dropdownMenuClassName: (index_module_default()).dropdownMenuSearch,
        className: (index_module_default()).select,
        onChange: val => {
          setType(val);
          setValue('');

          if (autoJumpWhenTypeChange) {
            const nextConfig = configs.find(item => item.id === val);
            router.push({
              pathname: nextConfig.listRouter
            });
          }
        },
        triggerProps: {
          className: (index_module_default()).selectDropdown,
          autoAlignPopupWidth: false,
          position: 'bl'
        },
        children: configs.map(item => /*#__PURE__*/(0,jsx_runtime.jsx)(Select/* default.Option */.Z.Option, {
          value: item.id,
          children: item.title
        }, item.id))
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(AutoComplete/* default */.Z, {
        inputProps: {
          ref: node => {
            // @ts-expect-error InputProps类型不支持ref，但实际功能正常
            inputRef.current = node;
          }
        },
        value: value,
        onChange: (val, option) => {
          setValue(val);
        },
        onFocus: () => {
          setIsFocus(true);
        },
        onBlur: () => {
          setIsFocus(false);
        },
        placeholder: currentConfig.placeholder,
        onPressEnter: handleSearch,
        className: classnames_default()((index_module_default()).input, inputClassName),
        triggerProps: {
          popupVisible: isFocus,
          className: (index_module_default()).popup,
          unmountOnExit: false,
          onClickOutside: () => {
            setIsFocus(false);
          }
        },
        loading: translateLoading,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(AutoComplete/* default.OptGroup */.Z.OptGroup, {
          children: !value && isFocus ? renderHistory() : renderResult()
        }, "key")
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: classnames_default()((index_module_default()).translateWrap, {
          [(index_module_default()).darkTranslate]: theme === 'dark'
        }),
        onClick: onTranslate,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(Tooltip/* default */.Z, {
          content: `${t['common.icon.translate']} ${t['common.to']} ${activeRegion.lang}`,
          children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: classnames_default()((index_module_default()).iconBlurred, {
              [(index_module_default()).iconFocused]: isFocus,
              [(index_module_default()).iconUnfocused]: !isFocus,
              [(index_module_default()).iconSelected]: translateLoading
            }, translateClassName),
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(ic_translate_blue_svg/* default */.Z, {}), t['common.icon.translate']]
          })
        })
      }), searchByImage && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "flex items-center justify-center cursor-pointer bg-white pr-2",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(Button/* default */.Z, {
          size: "small",
          onClick: () => setIsSearchByImageModalVisible(true),
          icon: /*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* MdMonochromePhotos */.jom, {
            className: "text-white text-lg"
          }),
          className: "rounded-lg bg-gradient-to-r from-[#655aec] to-[#a78bfa] text-white border-none transition-all duration-300 hover:shadow-lg hover:shadow-purple-400/40 hover:translate-y-[-1px] hover:brightness-110 relative overflow-hidden before:content-[''] before:absolute before:inset-0 before:bg-white/10 before:opacity-0 hover:before:opacity-100 before:transition-opacity",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
            className: "text-white ",
            children: t['search_by_image']
          })
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Button/* default */.Z, {
        className: classnames_default()((index_module_default()).btn, searchButtonClassName),
        type: "primary",
        icon: /*#__PURE__*/(0,jsx_runtime.jsx)(IconSearch/* default */.Z, {}),
        onClick: handleSearch
      })]
    }, "search")
  });
};

/* harmony default export */ var components_Search = (Search);

/***/ }),

/***/ 59544:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "VY": function() { return /* binding */ LayoutContext; },
/* harmony export */   "kn": function() { return /* binding */ GlobalContext; },
/* harmony export */   "o5": function() { return /* binding */ MobileLayoutContext; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _utils_language__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(39080);
/* harmony import */ var _utils_currency__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(88028);



const GlobalContext = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)({
  lang: _utils_language__WEBPACK_IMPORTED_MODULE_1__/* .Language.enUS */ .S.enUS,
  currency: _utils_currency__WEBPACK_IMPORTED_MODULE_2__/* .Currency.US */ .F.US,
  showMemberModalFromSSR: false,
  memberModalClosableFromSSR: true,
  isIntercomLoad: false
});
const LayoutContext = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)({
  showMemberModal: false,
  onShowMemberModal: () => {//
  },
  renderMemberModal: () => null,
  renderMaskMember: () => null,
  onHideMemberModal: () => {//
  },
  planTime: 'annually',
  planType: 'pro',
  showPaymentModal: false,
  paymentType: 'payment',
  subAccountCount: 0,
  originResData: {},
  onShowPaymentModal: () => {//
  },
  onHidePaymentModal: () => {//
  }
});
const MobileLayoutContext = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)({
  showMobileMemberModal: false,
  onShowMobileMemberModal: _ref => {//

    let {
      planType = 'basic',
      planTime = 'annually'
    } = _ref;
  }
});

/***/ }),

/***/ 27362:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"regionFlag":"index_regionFlag__leRyl","flagWarp":"index_flagWarp__ZY_SI","flag":"index_flag__ulsBs"};

/***/ }),

/***/ 73007:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"width-limit":"index_width-limit__fJNV9","overflow-hidden":"index_overflow-hidden__ZOWoj","loadingWrap":"index_loadingWrap__hioUb","loading":"index_loading__esLX0","echotik-revolve":"index_echotik-revolve___eEqq"};

/***/ }),

/***/ 92564:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"search":"index_search__AZlL_","select":"index_select__gBpvL","input":"index_input__AV42J","btn":"index_btn__56OrQ","dropdownMenuSearch":"index_dropdownMenuSearch__kLiwV","selectDropdown":"index_selectDropdown__h3xqX","popup":"index_popup__6F4ww","resultItem":"index_resultItem__a9lRe","cover":"index_cover__UB6f3","historyItemText":"index_historyItemText__3U6fl","title":"index_title__FWX_k","subtitle":"index_subtitle__r5zRE","fans":"index_fans__xSY_R","darkSearch":"index_darkSearch__ytZ_J","historyHeader":"index_historyHeader__8zNgS","historyTitle":"index_historyTitle__IrJI8","historyClear":"index_historyClear__a2kWc","historyItem":"index_historyItem__R7dzX","historyDelete":"index_historyDelete__6hCJl","translateWrap":"index_translateWrap__tduSI","darkTranslate":"index_darkTranslate__ldzE5","iconFocused":"index_iconFocused__2eMVf","fade-in":"index_fade-in__EBVtE","iconUnfocused":"index_iconUnfocused__Drdx6","fade-out":"index_fade-out___0QxR","iconBlurred":"index_iconBlurred__hmbTj","iconSelected":"index_iconSelected__WKeV7","border-color":"index_border-color__HBlfe"};

/***/ })

}]);